export default {
      id: "ar_menus-usage",
      viewBox: "0 0 75 75",
      url: "../dist/images/" + "sprite.svg#ar_menus-usage",
      toString: function () {
        return this.url;
      }
    }